import { connect } from 'react-redux'
import PupilHead from './title'
import { withRouter } from 'react-router'
import { getPupil } from '../../../../../stores/pupil/pupil.selectors'

const mapStateToProps = (state, { match }) => {
  const pupil = getPupil(state)
  return {
    name: `${pupil.account.first_name} ${pupil.account.last_name}`
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(PupilHead)
)
